(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/account-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/account-slice.js');

'use strict';

const {
  createSlice
} = RTK;
const {
  getInitialBalance
} = svs.gamePackage.redux.thunks;
const accountSlice = createSlice({
  name: 'account',
  initialState() {
    return {
      activeBalance: undefined,
      isSyndicate: false
    };
  },
  reducers: {
    updateBalance: (state, action) => {
      state.activeBalance = action.payload.balance;
    },
    setActiveAccount: (state, _ref) => {
      let {
        payload
      } = _ref;
      state.activeBalance = payload.balance;
      state.isSyndicate = payload.isSyndicate;
    }
  },
  extraReducers: {
    [getInitialBalance.fulfilled]: (state, action) => {
      state.activeBalance = state.activeBalance || action.payload.balance;
    }
  }
});
svs.gamePackage.redux.accountSlice = accountSlice;

 })(window);